var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGdeducationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04087 28.7025L32.9908 18.479C34.4852 17.8403 36.9077 17.8403 38.4021 18.479L62.352 28.7025C62.7254 28.8621 63.0055 29.0463 63.1923 29.243H63.3099V29.3856C63.5267 29.6931 63.5267 30.0225 63.3099 30.33V44.6005C63.6091 44.8098 63.7945 45.1011 63.7945 45.4236V48.2329C63.7945 48.8706 63.0671 49.3877 62.1698 49.3877C61.2725 49.3877 60.5461 48.8706 60.5461 48.2329V45.4236C60.5461 45.106 60.726 44.8186 61.0172 44.6099V31.5825L51.7464 35.5401L38.4016 41.2372C36.9077 41.8749 34.4852 41.8749 32.9908 41.2372L9.04087 31.0127C7.54643 30.3744 7.54643 29.3402 9.04087 28.7025ZM35.1002 44.4988L35.5502 44.6907H35.55C35.7983 44.7964 36.2015 44.7964 36.4498 44.6907C36.6981 44.585 36.8998 44.4988 36.8998 44.4988L49.3446 39.1865C50.8391 38.5488 52.0504 39.3491 52.0504 40.9738V46.7218C52.0504 51.3647 44.8646 55.1287 36.0001 55.1287C27.1366 55.1287 19.9512 51.3647 19.9512 46.7218V40.9738C19.9512 39.3491 21.1625 38.5488 22.6569 39.1865L35.1002 44.4988Z",
    fill: "url(#paint0_linear_8677_44492)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8677_44492",
    x1: 35.8573,
    y1: 10.5743,
    x2: 35.8573,
    y2: 55.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdeducationIcon);
export default __webpack_public_path__ + "static/media/gdeducation_icon.551e7f3974a7017a8c6a15433d7adbda.svg";
export { ForwardRef as ReactComponent };